import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import classnames from 'classnames'

import { ProductIds } from 'core/application/commons/config'

import useCurrentProduct from 'common/hooks/useCurrentProduct'

import './CommonStyles.less'

interface StepItemPageHeaderProps {
  title: string
  step: ReactNode
  info?: string
  numberOfSteps: number
  currentStep: number
  className?: string
  titleFontSize?: 20 | 30
}

const StepItemPageHeader: React.FC<StepItemPageHeaderProps> = (props) => {
  const product = useCurrentProduct()
  const { t: translate } = useTranslation()
  let textColorByProduct = product?.productId === ProductIds.GroupHraId ? '' : 'text-dark'
  const classNames = classnames({
    'medium-font-size': props.titleFontSize === 20,
    'large-font-size': props.titleFontSize === 30,
  })
  const infoContent = () => {
    return props.info ? <label className="info">{props.info}</label> : null
  }
  return (
    <div className={`category_item__header ${props.className}`}>
      <h2 className={`title ${classNames} ${textColorByProduct}`}>{props.title}</h2>
      <h4 className="question_progress">
        {translate('admin-signup.subscription.step')} {props.currentStep} {translate('admin-signup.subscription.of')}{' '}
        {props.numberOfSteps}
      </h4>
      <h5>{props.step}</h5>
      {infoContent()}
    </div>
  )
}

export default React.memo(StepItemPageHeader)
